import { BaseService } from "./baseService";
import httpRequest from "./index";

export class OcrService extends BaseService<any, any, any, any> {
    // 获取 ocr 识别后的信息
    public async businessLicense(fileId: number): Promise<unknown> {
        const { data } = await this.service.get(`${this.path}/businessLicense`, { params: { fileId } });
        return data;
    }
}
export const ocrService = new OcrService("/ocr", httpRequest);
